import { NewsAnnouncement, NewsEdition, shapeAnnouncements } from "./newsData";

// Live X is not called from this site. A future ingest should return NewsAnnouncement[]
// and replace readAnnouncementSeed. Keep the object shape; do not fetch from the browser.
export function readAnnouncementSeed(edition: NewsEdition): NewsAnnouncement[] {
  return shapeAnnouncements(edition.announcements);
}
